module.exports = __webpack_public_path__ + "ring-classic-granite.809da11d9e8119b53e49.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/ring-classic-granite.svg
// module id = ../../../../../src/assets/img/ring-classic-granite.svg
// module chunks = main